export default __webpack_public_path__ + "static/media/user.645fe31b.svg";